import { useSelector } from 'react-redux';
import { RootState } from '../../../../stores/store';
import {
  LEAK_TEST,
  VARIABLE_HARDNESS,
} from '../../../../_constants/inspectionConst';
import Standard from './DisplayPattern/Common/Standard';
import Matrix from './DisplayPattern/Common/Matrix';
import Accordion from './DisplayPattern/Common/Accordion';
import DtaImage from './DisplayPattern/Specific/DtaImage';
import { DTA_IMAGE_INSPECTION } from '../../../../_constants/inspectionConst';
import LeakTest from './DisplayPattern/Specific/LeakTest';
import VariableHardness from './DisplayPattern/Specific/VariableHardness';
import { isUnfilled } from '../../../../_utils/inspectionUtils';
import {
  GetInspectionItem,
  InspectionType,
} from '../../../../services/apiTypes';
import { INSPECTION_DISPLAY_TYPE } from '../../../../_constants/manageConst';
import { useEffect, useState } from 'react';

type InspectionMainProps = {
  typeLabel: string;
  typeData: InspectionType;
  beforeItemDataList: GetInspectionItem[];
};

const InspectionMain: React.FC<InspectionMainProps> = ({
  typeLabel,
  typeData,
  beforeItemDataList,
}) => {
  const { typeId } = useSelector((state: RootState) => state.selectIds);
  /** 先端部の画像コンポーネントを表示するか */
  const [isShowDtaImage, setIsShowDtaImage] = useState(false);

  useEffect(() => {
    setIsShowDtaImage(DTA_IMAGE_INSPECTION.typeIdList.includes(typeId));
  }, [typeId]);

  /** 特殊系画面は別途判定 */
  // 気密検査
  if (typeId === LEAK_TEST.typeId) {
    return (
      <LeakTest
        typeLabel={typeLabel}
        itemDataList={typeData.itemData}
        beforeItemDataList={beforeItemDataList}
        isUnfilled={isUnfilled(typeData.status)}
        isVisualInspection={typeData.isVisualInspection}
      />
    );
  }
  // 硬度可変測定
  if (typeId === VARIABLE_HARDNESS.typeId) {
    return (
      <VariableHardness
        typeLabel={typeLabel}
        itemDataList={typeData.itemData}
        isVisualInspection={typeData.isVisualInspection}
      />
    );
  }
  // 中項目の表示パターンで分岐
  switch (typeData.displayType) {
    case INSPECTION_DISPLAY_TYPE.STANDARD.value:
      return (
        <>
          <Standard
            typeLabel={typeLabel}
            itemDataList={typeData.itemData}
            beforeItemDataList={beforeItemDataList}
            isUnfilled={isUnfilled(typeData.status)}
            isVisualInspection={typeData.isVisualInspection}
          />
          {isShowDtaImage && <DtaImage markers={typeData.markers} />}
        </>
      );
    case INSPECTION_DISPLAY_TYPE.ACCORDION.value:
      return (
        <>
          <Accordion
            typeLabel={typeLabel}
            itemDataList={typeData.itemData}
            beforeItemDataList={beforeItemDataList}
            isUnfilled={isUnfilled(typeData.status)}
            isVisualInspection={typeData.isVisualInspection}
          />
          {isShowDtaImage && <DtaImage markers={typeData.markers} />}
        </>
      );
    case INSPECTION_DISPLAY_TYPE.MATRIX.value:
      return (
        <>
          <Matrix
            typeLabel={typeLabel}
            itemDataList={typeData.itemData}
            beforeItemDataList={beforeItemDataList}
            isUnfilled={isUnfilled(typeData.status)}
            isVisualInspection={typeData.isVisualInspection}
          />
          {isShowDtaImage && <DtaImage markers={typeData.markers} />}
        </>
      );
    default:
      return <></>;
  }
};

export default InspectionMain;
